import jsonFile from "../json/FarmHorsesOwnersABI.json";
const FarmHorsesOwnersABI = jsonFile;

export default FarmHorsesOwnersABI;  